import { DEFAULT_CONFIG } from "./constants";
import { EMOJI_TYPE } from "./types";
const pluginEmoji = (config) => {
  return {
    config: { ...DEFAULT_CONFIG, ...config },
    type: EMOJI_TYPE
  };
};
export {
  pluginEmoji
};
//# sourceMappingURL=viewer.js.map
